import clsx from "clsx";
import React from "react";
import { MenuItemProps } from "./MenuItem";
import SubMenuItem from "./SubMenuItem";

const HoverSubMenu = React.forwardRef(
  (
    { menuItems }: { menuItems?: MenuItemProps[] },
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <div className="fixed top-[112px] overflow-y-auto z-40 right-[10px] p-[14px]">
        <div
          ref={ref}
          className={clsx(
            " bg-white  border border-gray-100 shadow-lg rounded-lg",
            "cursor-default p-4 max-w-[490px]"
          )}
        >
          {menuItems?.map((item, index) => (
            <SubMenuItem
              key={index}
              item={item}
              highlight={index === 0}
              className="mb-2 last-of-type:mb-0"
            />
          ))}
        </div>
      </div>
    );
  }
);

export default HoverSubMenu;
